import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ReportesService } from '@reportes/reportes.service';
import { Meses } from '@shared/enums/Meses';
import { MessageService } from '@shell/message.service';
import { ErrorModel } from '@shared/models/ErrorModel';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-reporte-movimientos',
  templateUrl: './reporte-movimientos.component.html',
  styleUrls: ['./reporte-movimientos.component.scss']
})
export class ReporteMovimientosComponent {

  busqueda: UntypedFormGroup;
  cargandoReporte: boolean;
  listaReportes;
  meses = Meses;
  max = new Date().getFullYear();

  constructor(private fb: UntypedFormBuilder, private messageService: MessageService, 
    private reportesService: ReportesService, private spinner: NgxSpinnerService, private datePipe: DatePipe) {
    const fecha = new Date();
    this.busqueda = this.fb.group({
      anioFormControl: [fecha.getFullYear(), Validators.required]
    });
  }

  keysMeses(): Array<string> {
    let keys = Object.keys(this.meses);
    keys = keys.slice(keys.length / 2);
    return keys;
  }

  obtenerListaReportes() {
    this.cargandoReporte = true;
    this.spinner.show('spinnerGrafico');
    this.reportesService.obtenerListaReporteMovimientos(this.anioFormControl.value)
      .subscribe(res => {
        this.listaReportes = res;
        this.listaReportes.sort((a, b) => b.mes - a.mes)
        this.listaReportes.forEach(r => {
          r.fechaHoraCreacion = new Date(r.fechaHoraCreacion);
          const fechaMesCorriente = new Date();
          fechaMesCorriente.setDate(fechaMesCorriente.getDate() - 1);
          const fechaDesde = new Date(this.anioFormControl.value, r.mes - 1, 1);
          let fechaHasta;
          if(r.mes == fechaMesCorriente.getMonth() + 1 && r.ano == fechaMesCorriente.getFullYear()) {
            fechaHasta = this.datePipe.transform(fechaMesCorriente, 'dd/MM/yyyy');
          } else fechaHasta = this.datePipe.transform(new Date(fechaDesde.getFullYear(), fechaDesde.getMonth() + 1, 0), 'dd/MM/yyyy');

          r.desdeHasta = "Desde el " + this.datePipe.transform(fechaDesde, 'dd/MM/yyyy') + " hasta el " + fechaHasta;
          r.mes = Meses[r.mes];
          this.spinner.hide('spinnerGrafico');
          this.cargandoReporte = false;
        });
        this.cargandoReporte = false;
      }, (error: ErrorModel) => {
        this.messageService.showErrorMessage(error.description + " - " + error.message);
        this.spinner.hide('spinnerGrafico');
        this.cargandoReporte = false;
      });
  }

  get anioFormControl() {
    return this.busqueda.controls.anioFormControl;
  }

}
